export enum ChatParticipantType
{
    User,
    MedicalCenter,
    Group
}
